import { useMergeState } from '@/shared/lib/customHooks';

/**
 * Holds the patient impact drawer visibility for the RMA device information table. Keeps a single isVisiblePatientImpactDrawer flag in merge state and exposes a toggle for it.
 *
 * @returns Table state and the drawer toggle.
 */
const useDeviceInformationTable = () => {
  const [state, setState] = useMergeState({
    isVisiblePatientImpactDrawer: false,
  });

  /**
   * Opens or closes the patient impact drawer from the RMA device information table. Inverts the isVisiblePatientImpactDrawer flag in hook state.
   *
   * @returns Nothing.
   */
  const toggleDisplayDrawer = () => {
    setState({ isVisiblePatientImpactDrawer: !state.isVisiblePatientImpactDrawer });
  };

  return {
    state,
    toggleDisplayDrawer,
  };
};

export { useDeviceInformationTable };
